export const env = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  // Phase 4 OIDC. Defaults match deploy/keycloak/realm-todone.json so dev needs no .env edits.
  VITE_OIDC_AUTHORITY: import.meta.env.VITE_OIDC_AUTHORITY || 'http://localhost:8081/realms/todone',
  VITE_OIDC_CLIENT_ID: import.meta.env.VITE_OIDC_CLIENT_ID || 'todone-frontend',
  VITE_OIDC_REDIRECT_URI: import.meta.env.VITE_OIDC_REDIRECT_URI || `${window.location.origin}/`,
  VITE_OIDC_POST_LOGOUT_REDIRECT_URI:
    import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/login`,
} as const
